import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { McInput } from "../../../../../../components";
import { IGKMaalingAvLydtrykkResultater, IGKRapport } from "../../../../../../mc-shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../ReportBoard/ReportDocxImageContainer";

const MaalingAvLydtrykk: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKMaalingAvLydtrykkResultater;
}> = ({ data, onUpdateEditData }) => {
  return (
    <Card>
      <CardBody>
        <CardTitle tag="h4">Måling av lydtrykk</CardTitle>
        <div className="d-flex flex-column">
          <b>Fyll inn høyden på lukeåpningen &#40;cm&#41;:</b>
          <McInput
            value={data.inndata.hoeydePaaLukeaapning}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData("testResultater.maalingAvLydtrykk.inndata.hoeydePaaLukeaapning", Number(e.target.value))
            }
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-4">
          <b>Fyll inn målt A-vektet lydtrykk &#40;dB&#41;:</b>
          <McInput
            value={data.inndata.maaltLydtrykk}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData("testResultater.maalingAvLydtrykk.inndata.maaltLydtrykk", Number(e.target.value))
            }
            className="w-25"
          />
        </div>
        <div className="mt-4">
          <ReportDocxImageContainer docxImageTag="maalingAvLydtrykk" title="Bilde av målepunkt" />
          <div className="w-50">
            <b>Kommentar:</b>
            <McInput
              value={data.inndata.kommentar}
              onChange={(e) => onUpdateEditData("testResultater.maalingAvLydtrykk.inndata.kommentar", e.target.value)}
              type="textarea"
              dynamicHeight={true}
            />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default MaalingAvLydtrykk;
